import React, { Component } from 'react';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import Button from 'screens/components/basic/Button';
import { Link } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CardSimple from 'screens/components/basic/CardSimple';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class LegalContent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: "",
            value: 'a'
        };
    }

    // Change the tab 
    handleChange = (value) => {
        this.setState({
            value: value
        });
    };

    render() {

        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active">{LOOKUP.menu.admin.writing.legal.text}</li>
                </ol>
                <h2>{LOOKUP.menu.admin.writing.legal.title}</h2>
            </div>
        );

        return (
            <ContainerDivided headerContent={header}>
                <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                >
                    <Tab label="Terms & Conditions" value="a">
                        <CardSimple>
                            <h4 className="ml-1 mb-2 mt-3">Terms & Conditions</h4>
                            <Editor
                                editorClassName="legal_content"
                            />
                        </CardSimple>
                        <br />
                        <div className="row">
                            <div className="col-lg-12">
                                <Button name="buttonSave"
                                    className="pull-right"
                                    label={LOOKUP.menu.admin.coupon.controls.saveButton}
                                    primary={true} />
                                <Button name="buttonCancel"
                                    className="pull-right btn-space"
                                    label={LOOKUP.common.cancel.text} />
                            </div> {/* .col */}
                        </div> {/* .row */}
                    </Tab>
                    <Tab label="Privacy Policy" value="b">
                        <CardSimple>
                            <h4 className="ml-1 mb-2 mt-3">Privacy Policy</h4>
                            <Editor
                                editorClassName="legal_content"
                            />
                        </CardSimple>
                        <br />
                        <div className="row">
                            <div className="col-lg-12">
                                <Button name="buttonSave"
                                    className="pull-right"
                                    label={LOOKUP.menu.admin.coupon.controls.saveButton}
                                    primary={true} />
                                <Button name="buttonCancel"
                                    className="pull-right btn-space"
                                    label={LOOKUP.common.cancel.text} />
                            </div> {/* .col */}
                        </div> {/* .row */}
                    </Tab>
                </Tabs>
            </ContainerDivided>
        );
    }
}

export default LegalContent;